<template>
  <div class="is-flex is-align-content-center is-justify-content-center is-text-center"> 
    <button class="control-button-minus flex justify-center items-center" disabled>
      <img src="@/images/quote-builder/minus.svg" alt="Minus">
    </button>
     
    <div class="order-item-quantity flex items-center justify-center">
      <p>0</p>
    </div>   
    <button class="control-button-plus flex justify-center items-center" :disabled="loading" @click="addToQuote">
      <img src="@/images/quote-builder/plus.svg" alt="Plus">
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    priceBookEntry: {
      type: Object,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: mapState('quote', ['quote', 'priceBook', 'errors']),
  async created () {
    await this['pricing.get']()
  },
  methods: {
    ...mapActions('quote', ['pricing.get']),
    async addToQuote () {
      this.loading = true
      // create a quote via lead if none exists
      const quote = this.quote || await this.$store.dispatch('quote/quote.save')
      if (!quote) { return }
      await this.$store.dispatch('quote/quote.save', {       
        eventName: 'item.add',
        input: {
          item: {
            title: this.priceBookEntry.product.name,
            priceBookEntryId: this.priceBookEntry.id,
            quantity: this.quantity
          }
        }
      })
      this.loading = false
    }
  }
}
</script>

<style scoped>
.quote {
  padding: 1em;
  border: 1px solid blue;
}
</style>

<style lang="scss" scoped>
.control-button:hover {
  cursor: pointer;
  background-color: #d6d6d6;
}
.quantity-display {
  text-align: center;
  margin: 0px;
  padding: 7px 16px;
  background-color: white;
  font-weight: bold;
}
.control-button-minus {
  width: 44px;
  height: 44px;
  background-color: #f3f1ed;
  border: 1px solid #e8e3db;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.control-button-plus {
  width: 44px;
  height: 44px;
  background-color: #f3f1ed;
  border: 1px solid #e8e3db;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.is-small {
  .control-button {
    width: auto;
    padding: 4px 7px;
  }
  .quantity-display {
    padding: 5px 10px;
  }
}

.order-item-quantity {
  width: 44px;
  height: 44px;
  background-color: #FFF;
  border: 1px solid #EDE9E3;
}

.order-item-quantity p {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  letter-spacing: -0.02em;
  color: #334155;
}

</style>
